// client/src/routes/app/tenants/$tenantId/history.tsx — SCR-TEN-002 tab „Istoric" · TEN-004,
// the chronological history since D-2864.

import { createFileRoute } from '@tanstack/react-router';

import { HistoryTab } from '@/features/tenants/HistoryTab';

export const Route = createFileRoute('/app/tenants/$tenantId/history')({
  component: HistoryTabScreen,
});

function HistoryTabScreen() {
  const { tenantId } = Route.useParams();
  return <HistoryTab tenantId={tenantId} />;
}
